import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';

export const ComplyAdvantageSearchDtoSchema = z
    .object({
        name: z.string(),
        jurisdictionCode: z.string(),
        companyId: z.string().optional(),
    })
    .strict();

export class ComplyAdvantageSearchDto extends FromSchema(ComplyAdvantageSearchDtoSchema) {
    name: string;
    jurisdictionCode: string;
    companyId?: string;
}
